import React, { useEffect, useRef, useState } from 'react'
import { Form, App, Input, Modal } from 'antd';
import { useBnsXiangMuXuQiuAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';
import MyEditor from '../../cpn/MyEditor';
import ClientSelect from '../client/ClientSelect';
function ModuleAddCopy(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info, setInfo] = useState({
        'bxmxq_bxm_id':props.bxm_id,
        'bxmxq_bxm_name': props.bxm_name,
        'bxmxq_cid': props.eu_id,
        'bxmxq_cname': props.eu_name,
        'bxmxq_name': props.bxmxq_name,
        'bxmxq_content': props.bxmxq_content,
        bxmxq_yh_id:'',
        bxmxq_yh_name:'',
    });    
    const [add] = useBnsXiangMuXuQiuAddMutation();
    const handleOk = () => {
        form.validateFields().then(values => {
            add(info).then((res) => {
                if (res.data.Status === 'success') {
                    message.info('新增成功！');
                    setOpen(false);
                    form.resetFields();
                } else if (res.data.Status === "fail") {
                    message.error('新增失败！' + res.data.Message);
                }
            });
        }).catch(error => {
            console.error('表单验证失败:', error);
        });
    };
    const editForm = useRef();
    useEffect(() => {
        if(open){
            editForm.current.setFieldsValue({
                bxmxq_name:props.bxmxq_name,
                bxmxq_content:props.bxmxq_content,
            })
        }
    },[props,open]);
    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 复制新增</a>
            <Modal
                open={open}
                width={800}
                title="新增模块"
                onCancel={() => { setOpen(false); form.resetFields(); }}
                onOk={handleOk}
                
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_module_add_copy"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 11 }}
                    ref={editForm}
                >
                    <ClientSelect
                        name="bxmxq_cid"
                        label="客户端"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请选择客户端' }]}
                        bxm_id={props.bxm_id}
                        bxm_name={props.bxm_name}
                        eu_id={props.eu_id}
                        eu_name={props.eu_name}
                        style={{ width: '200px' }}
                        onChange={(e,f) => {
                            setInfo(prevState => ({ ...prevState, bxmxq_yh_id:e, bxmxq_yh_name: f }))
                        }}
                    />
                    <Form.Item
                        name="bxmxq_name"
                        label="模块名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入模块名称' }]}
                    >
                        <Input
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, bxmxq_name: e.target.value })) }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="bxmxq_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <MyEditor
                            onChange={(e) => {
                                setInfo(prevState => ({ ...prevState, bxmxq_content: e }))
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModuleAddCopy;
